import React, { Fragment, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { Popconfirm } from "antd";
import {
  faPencilAlt,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";

import { getStaticPages } from "./requests/getStaticPages";
import { deleteStaticPages } from "./requests/deleteStaticPages";
import useSearchHook from "../../../hooks/useSearch.hook";
import Filters from "./filters";

const StaticPages = (props) => {
  const [loading, setLoading] = useState(true);
  const [pageItems, setPageItems] = useState([]);
  const {
    getList,
  } = props;

  const {
    page,
    size,
    sort,
    filters,
    handlePageChange,
    handleSortedChange,
    handlePageSizeChange
  } = useSearchHook(getList, {
    size: 30,
    sort: "date,desc",
    callback: setPageItems,
    setLoading,
  });

  const reload = () => {
    getList(page, size, sort, filters, setPageItems, setLoading);
  };

  const handleCreate = (data) => {

  };

  const handleDelete = (id) => {
    setLoading(true);
    deleteStaticPages(id)
      .then(() => {
        toast("Static Page removed successfully", {
          type: toast.TYPE.SUCCESS,
        });
        reload();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getColumns = () => [
    {
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Title",
      accessor: "title",
    },
    {
      Header: "Path",
      accessor: "path",
    },
    {
      Header: "Language",
      accessor: "language",
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Fragment>
          <Link to={`/static-pages/edit/${original.id}`} className="btn btn-sm mx-2 btn-warning">
            <FontAwesomeIcon icon={faPencilAlt}/>
          </Link>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => handleDelete(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger mx-2">
              <FontAwesomeIcon icon={faTimes}/>
            </button>
          </Popconfirm>
        </Fragment>
      ),
    }
  ];

  return (
    <div className="w-100 p-2">
      <div className="filters">
        <Filters
          activeFilters={[]}
          totalCount={false}
          handleCreate={() => handleCreate()}
        />
      </div>
      <ReactTable
        data={pageItems || []}
        headerClassName="table-header"
        columns={getColumns()}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight table-header-padding"
        loading={loading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        style={{
          height: "calc(100vh - 140px)"
        }}
        manual={true}
        page={page}
        pageSize={size}
        onSortedChange={handleSortedChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getStaticPages, dispatch),
});

export default connect(
  null,
  mapStateToDispatch
)(StaticPages);



// WEBPACK FOOTER //
// ./src/views/pages/static-pages/index.js